import React from "react";
import { Link } from "react-router-dom";
import FilmanizeCheckbox from "../../../shared/filmanize-checkbox";
import './day-out-of-days.scss';
import CanAccessLink from "../../../shared/can-access-link";

const DayOutOfDaysCrewTableEdit = (props) => {
    const {
        crewMembers,
        days,
        hasDates,
        filmId,
        showNonShootingDays,
        canAccessCrew,
        onCrewDayToggle,
        onCrewMemberToggleAll
    } = props;

    const filteredDays = showNonShootingDays ? days : days.filter((d: any) => !d.isOffDay);

    const handleNameClick = (crewMember) => {
        if (onCrewMemberToggleAll) {
            onCrewMemberToggleAll(crewMember);
        }
    };

    const handleDayToggle = (crewMember, day, isChecked) => {
        if (onCrewDayToggle) {
            onCrewDayToggle(crewMember, day, isChecked);
        }
    };

    return (
        <div className="day-out-days-table-container">
            <table className="table day-out-days-table">
                <thead className="day-out-days-table-header-row">
                    <tr>
                        <th className="day-out-days-table-actor-column">Name</th>
                        <th>Department</th>
                        <th>Role</th>
                        {(filteredDays || []).map((day: any, index: number) => (
                            <th className="has-text-centered" key={index}>
                                {day.number && <Link to={`/films/${filmId}/shooting-days/${day.id}/crew`}>Day {day.number}</Link>}
                                {!day.number && <span>Off Day</span>}
                            </th>
                        ))}
                        {hasDates && <th className="has-text-centered" colSpan={2}>Total</th>}
                        {!hasDates && <>
                            <th className="has-text-centered">Total Work</th>
                            <th className="has-text-centered">Total Hold</th>
                        </>}
                    </tr>
                    {hasDates &&
                        <tr>
                            <th className="day-out-days-table-actor-column"></th>
                            <th></th>
                            <th></th>
                            {(filteredDays || []).map((day: any, index: number) => (
                                <th className="has-text-centered" key={index}>{new Date(day.date).toLocaleDateString()}</th>
                            ))}
                            <th className="has-text-centered">Work</th>
                            <th className="has-text-centered">Hold</th>
                        </tr>
                    }
                </thead>
                <tbody>
                    {(crewMembers || []).map((crewMember, index) => {
                        return (
                            <tr key={index}>
                                <td className="day-out-days-table-actor-column">
                                    <span
                                        style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                        onClick={() => handleNameClick(crewMember)}
                                    >
                                        {crewMember.name}
                                    </span>
                                </td>
                                <td className="day-out-days-table-deptartment-column">
                                    <CanAccessLink to={`/films/${filmId}/departments/${crewMember.crewDepartmentId}/edit`} canAccess={canAccessCrew}>
                                        {crewMember.crewDepartmentName}
                                    </CanAccessLink>
                                </td>
                                <td className="day-out-days-table-role-column">
                                    <CanAccessLink to={`/films/${filmId}/departments/${crewMember.crewDepartmentId}/roles/${crewMember.crewRoleId}/edit`} canAccess={canAccessCrew}>
                                        {crewMember.crewRoleName}
                                    </CanAccessLink>
                                </td>
                                {(crewMember.days.filter((d: any) => showNonShootingDays || d.number) || []).map((day: any, dayIndex: number) => {
                                    const isWorking = day.start || day.work || day.finish;
                                    const isHold = day.hold;
                                    const isSelected = isWorking || isHold;

                                    return (
                                        <td className="has-text-centered" key={dayIndex}>
                                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                <FilmanizeCheckbox
                                                    checked={isSelected}
                                                    onChange={(checked) => handleDayToggle(crewMember, day, checked)}
                                                    label=""
                                                    disabled={!day.dayId}
                                                />
                                            </div>
                                        </td>
                                    );
                                })}
                                <td className="has-text-centered">{crewMember.totalWorkDays}</td>
                                <td className="has-text-centered">{crewMember.totalHoldDays}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default DayOutOfDaysCrewTableEdit;
